import PropTypes from 'prop-types';

const HeaderImage = ({ image }) => (
  <div className="relative mb-4 overflow-hidden rounded-lg">
    <img 
      src={`${image}`} 
      alt="Nigerian flags" 
      className="object-cover w-full h-[300px]"
    />
  </div>
);

HeaderImage.propTypes = {
  image: PropTypes.string,
};

export default HeaderImage;